import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

import { ApiService } from '@services/api.service';
import { PainelFinanceiroInfo } from '../models/painel-financeiro-info';

@Injectable({
  providedIn: 'root'
})
export class PainelFinanceiroApiService extends ApiService {

  baseUrlRoute: string = "painel-financeiro";

  constructor(
    public override http: HttpClient,
  ) {
    super(http);
  }

  public criarContaBancoImportandoConciliacao(file: File): Observable<void> {
    const formData = new FormData();
    formData.append('formFile', file, file.name);

    return this.post<void>(`/conciliacao-excel/criar-conta-banco-importando-conciliacao`, null, formData);
  }
  
  public getPainelFinanceiroInfo(): Observable<PainelFinanceiroInfo> {
    return this.get<PainelFinanceiroInfo>(`/${this.baseUrlRoute}`);
  }
}
